/**
 * Azul DAE technical-call meeting minutes seed.
 * Bump AZUL_MINUTES_REVISION in operator-progress-projects.mjs when this content changes.
 */

function newId(prefix) {
  return `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
}

function minuteFromTopic({ number, title, body, owner = "Azul / DAE", priority = "NORMAL", nextAction = "" }) {
  const now = new Date().toISOString();
  const text = String(body || "").trim();
  return {
    id: newId("min"),
    number: String(number),
    sectionNumber: String(number),
    principalTopic: title,
    subTopic: title,
    owner,
    status: "open",
    targetOriginal: "",
    targetUpdated: "",
    comments: text
      ? [{ id: newId("cmt"), text, at: now, by: "system" }]
      : [],
    _tracker: {
      status: "IN PROGRESS",
      priority,
      history: text
        ? [{ date: now.slice(0, 10), text, source: "meeting" }]
        : [],
      nextAction: nextAction || "",
      nextActionBy: owner,
      targetDate: "",
      nextActions: nextAction ? [nextAction] : [],
    },
  };
}

/** Latest Azul technical-call minutes (replaces prior history on revision bump). */
export function buildAzulCallMinutes() {
  return [
    minuteFromTopic({
      number: 1,
      title: "Outgoing Engine Records",
      priority: "CRITICAL",
      owner: "Azul",
      nextAction: "Azul to complete the records on an urgent basis. DAE to review and revert.",
      body: `Azul is uploading updates to the records. ED0569 and ED0570 are top priority.

Action: Azul to complete the records on an urgent basis. DAE to review and revert.`,
    }),
    minuteFromTopic({
      number: 2,
      title: "Engine Swap Shipping Cost Reimbursement",
      owner: "Azul",
      nextAction: "Azul to issue an invoice upon completion of the outgoing engine Records for the swaps.",
      body: `DAE has provided its final review, authorizing an amount of USD 86,900.23. Azul has reviewed the analysis and verbally agreed to this amount.

Action: Azul to issue an invoice upon completion of the outgoing engine Records for the swaps.`,
    }),
    minuteFromTopic({
      number: 3,
      title: "Engines in Shop – Schedule",
      owner: "DAE / Azul",
      body: `ED0655: Released from PW Sorocaba on 2-Aug; arrived at Azul facilities.

ED1019, ED1040: Serviceable. Payment scheduled for 13-Aug. DAE has contacted the shop requesting release ASAP given the scheduled payment. StdAero is reviewing internally.

HPT blade material shortages are affecting the following engines. AOG orders have been placed on all of them in an effort to improve TAT:
- ED1025: pushed to Oct 2026
- ED0682: pushed to Sep 2026
- ED1008: pushed to mid-Oct 2026
- ED1141: pushed to Nov 2026

ED0542: TAT improved from 15-Dec to the first week of November 2026 (estimated).`,
    }),
    minuteFromTopic({
      number: 4,
      title: "Utilization Reports",
      owner: "Azul",
      priority: "CRITICAL",
      nextAction: "Azul to action this ASAP on the DAE portal.",
      body: `Azul support required to update/correct last month's reports.

Action: Azul to action this ASAP on the DAE portal.`,
    }),
    minuteFromTopic({
      number: 5,
      title: "Parts Status",
      owner: "Azul / DAE",
      body: `No update provided on today's call.

Rejected parts (65 total):
- 13 blades released to service.
- 9 remaining blades: in APS, workscope under review.
  - APS has suggested overhaul (OVH) of 7 blades.
  - APS has declared 2 blades BER. Azul will request a technical report from APS to support this condition.

Propeller hubs (4 total):
- 2 will be released for MSN 1088; Azul will cover the associated costs.
- Remaining parts: Action — Azul to provide a report on the remaining units. It was noted that 4 might be BER.

26 Critical Parts (Azul support request):
- MFCU: USD 99K + overhaul of core (could reach USD 180K). Azul's internal review is in progress, working with ATR to take on this component. No update provided on this call.
- Azul has formally requested DAE's support in directly contacting ATR to expedite supply of critical parts delaying landing gear (LG) release from the shop and return to service of the inactive fleet. Azul is working on the materials list with issues. No update provided on this call.`,
    }),
    minuteFromTopic({
      number: 6,
      title: "Landing Gear Swaps",
      owner: "Azul",
      nextAction: "Azul to confirm the schedule for removal and shipping of the off-units back to DAE.",
      body: `NLG from ADP France: Arrived in Brazil, still held in customs (missing fumigation stamp. container needs to be incinerated and the LG transferred to a new container). Due to Azul manpower shortage, this has not yet been actioned. Release expected within 15 days. (NLG assigned to MSN 1080 — not affecting TAT.) No update provided on this call.

Other LG swap core returns: Azul has created removal work orders for units to be returned to DAE. Azul reports a manpower shortage for removing these gears without affecting the return to service and operation of other aircraft.

Action: Azul to confirm the schedule for removal and shipping of the off-units back to DAE. Shipping details have been provided by email.`,
    }),
    minuteFromTopic({
      number: 7,
      title: "12-Aircraft Return-to-Service Plan",
      owner: "Azul / DAE",
      body: `MSN 1088: CRS 17-Aug. Paint to follow, with release by 1-Oct. Components have been robbed from MSN 1080 to support MSN 1088; DAE Procurement is supporting the process of replacing those parts. No update provided on this call.

MSN 1190: Ferried to MRO in PLU. Induction 7-Aug. First revenue flight scheduled for 25-Sep.

AMC Program (ATR): Azul has joined the program for MSN 1190, which supports return to service of the aircraft. No update on this call.

External MROs: Slots and MRO not yet confirmed.`,
    }),
    minuteFromTopic({
      number: 8,
      title: "LG Insurance Claims",
      owner: "Azul / DAE",
      body: `Azul has requested DAE's approval to release the claim. Outstanding records are required, and internal approval will begin by 7-Aug.`,
    }),
    minuteFromTopic({
      number: 9,
      title: "Surveillances",
      owner: "Azul / DAE",
      body: `Records for 14 aircraft have been provided; auditors are requesting the outstanding records. Records for 14 aircraft remain pending.

7 inspections performed, 5 scheduled, 16 to be confirmed by Azul.`,
    }),
  ];
}
